/**
 * Core Switch (Toggle) — wraps Radix Switch.
 */
import React from 'react';
import * as RadixSwitch from '@radix-ui/react-switch';
import { cn } from '@/lib/utils';

export interface SwitchProps {
  id?: string;
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
  className?: string;
  size?: 'sm' | 'md';
}

export const Switch: React.FC<SwitchProps> = ({ id, checked, onCheckedChange, disabled, label, className, size = 'md' }) => (
  <div className={cn("flex items-center gap-2", className)}>
    <RadixSwitch.Root
      id={id}
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      className={cn(
        "peer inline-flex shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-[var(--primary-color)] data-[state=unchecked]:bg-slate-200 dark:data-[state=unchecked]:bg-slate-700",
        size === 'sm' ? 'h-4 w-8' : 'h-5 w-10'
      )}
    >
      <RadixSwitch.Thumb className={cn(
        "pointer-events-none block rounded-full bg-white shadow-lg ring-0 transition-transform data-[state=unchecked]:translate-x-0",
        size === 'sm' ? 'h-3 w-3 data-[state=checked]:translate-x-4' : 'h-4 w-4 data-[state=checked]:translate-x-5'
      )} />
    </RadixSwitch.Root>
    {label && <label htmlFor={id} className="text-sm text-gray-700 dark:text-slate-300 cursor-pointer select-none">{label}</label>}
  </div>
);
export default Switch;
